import { addMutator } from '@poa/state';

import { fetchWallet, fetchWalletSuccess, fetchWalletFailed } from './wallet.actions';

// fetch
addMutator(fetchWallet, (payload, { store }) => {
  store.wallet.meta.isLoading = true;
  store.wallet.meta.hasError = false;
});

addMutator(fetchWalletSuccess, ({ data }, { store }) => {
  store.wallet.meta.isLoading = false;
  store.wallet.meta.hasError = false;
  store.wallet.data.replace(data);

  store.wallet.meta.loaded = true;
});

addMutator(fetchWalletFailed, (payload, { store }) => {
  store.wallet.meta.isLoading = false;
  store.wallet.meta.hasError = true;
});
